<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="600px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card tile>
            <v-card-text>
                <v-img
                    v-if="filePreviewUri"
                    :src="filePreviewUri"
                    contain
                    class="mt-4"
                />
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn text color="info" data-sentry-label="Zamknij" @click="onClose">
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>

export default {
    name: 'ImagePreviewDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        filePreviewUri: {
            type: String,
            default: null
        }
    },
    methods: {
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>